import { apiGet, apiDelete } from '../utils/api';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export interface ModelMetadata {
  id: string;
  name: string;
  description: string;
  created_at: string;
  updated_at: string;
  config_name: string;
  metrics?: {
    nrmse_train?: number;
    nrmse_val?: number;
    r2?: number;
    adj_r2?: number;
    decomp_rssd_val?: number;
  };
}

/**
 * Service for managing saved trained models
 */
export const modelService = {
  /**
   * List all saved trained models
   */
  async listModels(logto: any): Promise<ModelMetadata[]> {
    try {
      const data = await apiGet<{ success: boolean; models: ModelMetadata[] }>(
        `${API_BASE}/api/v1/models`,
        logto
      );
      return data.models || [];
    } catch (error) {
      console.error('Error listing models:', error);
      return [];
    }
  },

  /**
   * Get a specific model's metadata
   */
  async getModel(logto: any, modelId: string): Promise<{ success: boolean; model?: ModelMetadata; message?: string }> {
    try {
      return await apiGet(
        `${API_BASE}/api/v1/models/${modelId}`,
        logto
      );
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  },

  /**
   * Get the full results for a saved model
   */
  async getModelResults(logto: any, modelId: string): Promise<{ success: boolean; results?: any; message?: string }> {
    try {
      return await apiGet(
        `${API_BASE}/api/v1/models/${modelId}/results`,
        logto
      );
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  },

  /**
   * Get the configuration for a saved model
   */
  async getModelConfig(logto: any, modelId: string): Promise<{ success: boolean; config?: any; message?: string }> {
    try {
      return await apiGet(
        `${API_BASE}/api/v1/models/${modelId}/config`,
        logto
      );
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  },

  /**
   * Delete a model
   */
  async deleteModel(logto: any, modelId: string): Promise<{ success: boolean; message: string }> {
    try {
      return await apiDelete(
        `${API_BASE}/api/v1/models/${modelId}`,
        logto
      );
    } catch (error) {
      return {
        success: false,
        message: error instanceof Error ? error.message : 'Unknown error',
      };
    }
  },
};

